// 默认启用的工具栏按钮
export const DEFAULT_TOOLBAR_BUTTONS = [
    "bold",
    "italic",
    "underline",
    "strikethrough",
    "fontColor",
    "alignLeft",
    "alignCenter",
    "alignRight",
    "bulletList",
    "orderedList",
    "insertImage",
    "insertLink",
    "insertTable",
    "deleteTable",
    "horizontalRule",
    "undo",
    "redo",
];

// 工具栏按钮分组配置
export const BUTTON_GROUPS = [
    {
        title: "文本格式",
        buttons: ["bold", "italic", "underline", "strikethrough"],
    },
    {
        title: "颜色",
        buttons: ["fontColor"],
    },
    {
        title: "对齐方式",
        buttons: ["alignLeft", "alignCenter", "alignRight"],
    },
    {
        title: "列表",
        buttons: ["bulletList", "orderedList"],
    },
    {
        title: "插入",
        buttons: ["insertImage", "insertLink", "insertTable", "deleteTable", "horizontalRule"],
    },
    {
        title: "操作",
        buttons: ["undo", "redo"],
    },
];

// 编辑器默认配置
export const EDITOR_CONFIG = {
    starterKit: {
        dropcursor: {
            color: "#1890ff",
            width: 3,
        },
    },
    textAlign: {
        types: ["heading", "paragraph"],
    },
    table: {
        resizable: true,
    },
    mention: {
        HTMLAttributes: {
            class: "content-block-mention",
        },
    },
};
 